import { RolesEnum } from '@irembo-andela/irembogov3-common';

export const UserCanConfigureServiceChangeRequests: RolesEnum[] = [
  RolesEnum.ROLE_SERVICE_MANAGER,
];

export const UserCanReviewServiceChangeRequests: RolesEnum[] = [
  RolesEnum.ROLE_QA_REVIEWER,
];

export const UserCanViewServiceChangeRequests: RolesEnum[] = [
  RolesEnum.ROLE_SERVICE_MANAGER,
];
